import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "instant"
};
const _hoisted_2 = {
  class: "theme-border-half panel",
  style: {
    "text-align": "left",
    "padding": "3px 3px 30px 3px"
  }
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "mydialogtitle"
}, "明细", -1);

const _hoisted_4 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 2
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 第 ");

const _hoisted_9 = {
  style: {
    "color": "#409eff"
  }
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("期 ");

const _hoisted_11 = {
  style: {
    "color": "#409eff"
  }
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("@ ");

const _hoisted_13 = {
  style: {
    "color": "#f56c6c"
  }
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "mydialogtitle"
}, "快速补货", -1);

const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  style: {
    "color": "#007dfa"
  }
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("全部快速填入");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_19 = {
  style: {
    "text-align": "right"
  }
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("全部补出");

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "mydialogtitle"
}, "补货明细", -1);

const _hoisted_23 = /*#__PURE__*/_createTextVNode("关 闭");

const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "mydialogtitle"
}, "补货明细", -1);

const _hoisted_25 = {
  style: {
    "color": "#409eff"
  }
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode("返 回");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_gameinfo = _resolveComponent("gameinfo");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_link = _resolveComponent("el-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_gameinfo, {
    ref: "gameinfo",
    game_info_data: $data.game_info_data,
    is_manlet: $data.is_manlet,
    onGet_game_info: $options.get_game_info,
    onChange_xuzhu_shizhan: $options.change_xuzhu_shizhan,
    onUpdeta_pl_value: $options.updeta_pl_value,
    onChange_pk: $options.changepk,
    onFast_bh: $options.fast_bh,
    onGet_bhmx: $options.get_bhmx
  }, null, 8, ["game_info_data", "is_manlet", "onGet_game_info", "onChange_xuzhu_shizhan", "onUpdeta_pl_value", "onChange_pk", "onFast_bh", "onGet_bhmx"]), (_openBlock(), _createBlock(_resolveDynamicComponent($data.comp), {
    ref: $data.comp,
    params: $data.params,
    game_info_data: $data.game_info_data,
    title: $data.game_info_data.title,
    chang_long: $data.chang_long,
    sum: $data.sum,
    loss_data: $data.loss_data,
    zupai: $data.zupai,
    balls: $data.balls,
    is_manlet: $data.is_manlet,
    pl_value: $data.pl_value,
    pk: $data.pk,
    szsz: $data.szsz,
    onChange_submenu: $options.change_submenu,
    onChange_pk: $options.changepk,
    onChange_pl: $options.change_pl,
    onGet_zdmx_data: $options.get_zdmx_data,
    onChange_play: $options.change_play,
    onChange_zupai_type: $options.change_zupai_type,
    onChange_zupai_page: $options.change_zupai_page,
    onUpdate_zupai: $options.update_zupai
  }, null, 8, ["params", "game_info_data", "title", "chang_long", "sum", "loss_data", "zupai", "balls", "is_manlet", "pl_value", "pk", "szsz", "onChange_submenu", "onChange_pk", "onChange_pl", "onGet_zdmx_data", "onChange_play", "onChange_zupai_type", "onChange_zupai_page", "onUpdate_zupai"]))]), $data.zdmx.visible ? (_openBlock(), _createBlock(_component_el_dialog, {
    key: 0,
    modelValue: $data.zdmx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.zdmx.visible = $event),
    width: "820px",
    class: "mydialogclass",
    onClose: _cache[2] || (_cache[2] = $event => $data.zdmx.page = 1)
  }, {
    header: _withCtx(() => [_hoisted_3]),
    footer: _withCtx(() => [_createVNode(_component_el_pagination, {
      class: "paging",
      "hide-on-single-page": "",
      onCurrentChange: $options.zdmx_change_page,
      small: "",
      modelValue: $data.zdmx.page,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.zdmx.page = $event),
      "page-size": 30,
      "pager-count": 5,
      total: $data.zdmx.pagination.total_records * 1,
      layout: " total,prev, pager, next, jumper,"
    }, null, 8, ["onCurrentChange", "modelValue", "total"])]),
    default: _withCtx(() => [_createVNode(_component_el_table, {
      data: $data.zdmx.data_list,
      border: "",
      size: "small",
      "highlight-current-row": "",
      "header-cell-class-name": "table-header-cell",
      "header-row-class-name": "table-header-row",
      "table-layout": "auto"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        property: "order_id",
        label: "注单号/时间",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.order_id), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$filters.time(scope.row.posttime)), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "username",
        label: "会员/盘口",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", _hoisted_4, _toDisplayString(scope.row.username), 1), _createElementVNode("div", null, [scope.row.level_id.includes('1') ? (_openBlock(), _createElementBlock("span", _hoisted_5, "A盘")) : _createCommentVNode("", true), scope.row.level_id.includes('2') ? (_openBlock(), _createElementBlock("span", _hoisted_6, "B盘")) : _createCommentVNode("", true), scope.row.level_id.includes('3') ? (_openBlock(), _createElementBlock("span", _hoisted_7, "C盘")) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "s_type",
        label: "下注类型",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", null, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(scope.row.qnum), 1), _hoisted_10]), _createElementVNode("div", null, _toDisplayString(scope.row.game_name), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "bet_info",
        label: "下注明细",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_11, _toDisplayString(scope.row.title) + "『" + _toDisplayString(scope.row.bet_name) + "』", 1), _hoisted_12, _createElementVNode("span", _hoisted_13, _toDisplayString(scope.row.list_bonus), 1)])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "balance",
        label: "会员下注",
        align: "center"
      })]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: $data.zupai.show_ksbh,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.zupai.show_ksbh = $event),
    class: "mydialogclass",
    top: "80px",
    width: "600px"
  }, {
    header: _withCtx(() => [_hoisted_14]),
    footer: _withCtx(() => [_createVNode(_component_el_input, {
      size: "small",
      modelValue: $data.zupai.ksbh_all_input,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.zupai.ksbh_all_input = $event),
      class: "ksbhkj",
      style: {
        "width": "250px",
        "float": "left",
        "margin": "0 0 5px 0"
      }
    }, {
      prepend: _withCtx(() => [_hoisted_17]),
      append: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.sub_ksbh_all_input
      }, {
        default: _withCtx(() => [_hoisted_18]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
      type: "",
      size: "default",
      onClick: _cache[4] || (_cache[4] = $event => $data.zupai.show_ksbh = false)
    }, {
      default: _withCtx(() => [_hoisted_20]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      size: "default",
      onClick: $options.sub_ksbh
    }, {
      default: _withCtx(() => [_hoisted_21]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_table, {
      data: $data.zupai.list,
      border: "",
      size: "samll",
      "highlight-current-row": "",
      "header-cell-class-name": "table-header-cell",
      "header-row-class-name": "table-header-row",
      "table-layout": "auto"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        property: "let.name",
        label: "号码",
        align: "center"
      }, {
        default: _withCtx(scope => [$data.balls == 'zm1_6' ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row.game_type) + "：", 1)) : _createCommentVNode("", true), _createElementVNode("span", {
          style: _normalizeStyle({
            color: scope.row.color
          })
        }, _toDisplayString(scope.row.name), 5)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "let.oc_bill",
        label: "下注额",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        property: "let.list_bonus",
        label: "赔率",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", _hoisted_16, _toDisplayString(scope.row.let.list_bonus), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "let.control_let",
        label: "金额",
        align: "center",
        width: "150"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_input, {
          size: "small",
          modelValue: scope.row.let.control_let,
          "onUpdate:modelValue": $event => scope.row.let.control_let = $event,
          disabled: scope.row.let.oc_bill <= 0
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.bhmx.visible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.bhmx.visible = $event),
    class: "mydialogclass",
    top: "80px",
    width: "600px"
  }, {
    header: _withCtx(() => [_hoisted_22]),
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      size: "default",
      onClick: _cache[6] || (_cache[6] = $event => $data.bhmx.visible = false)
    }, {
      default: _withCtx(() => [_hoisted_23]),
      _: 1
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table, {
      data: $data.bhmx.list,
      "show-summary": "",
      "summary-method": $options.bhmx_sum,
      border: "",
      ref: "tableRef",
      size: "samll",
      "highlight-current-row": "",
      "header-cell-class-name": "table-header-cell",
      "header-row-class-name": "table-header-row"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        property: "ball",
        label: "号码",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", {
          style: _normalizeStyle({
            color: scope.row.color
          })
        }, _toDisplayString(scope.row.ball), 5)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "num",
        label: "笔数",
        align: "center"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_link, {
          type: "primary",
          onClick: $event => $options.get_bhmx(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.num), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "control_let",
        label: "补出金额",
        align: "center"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_link, {
          type: "primary",
          onClick: $event => $options.get_bhmx(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.control_let), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "yk",
        label: "剩余盈亏值",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", {
          style: _normalizeStyle({
            color: scope.row.yk < 0 ? 'red' : '#000'
          })
        }, _toDisplayString(scope.row.yk), 5)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data", "summary-method"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.bhmx.ball_mx.visible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.bhmx.ball_mx.visible = $event),
    class: "mydialogclass",
    top: "80px",
    width: "800px"
  }, {
    header: _withCtx(() => [_hoisted_24]),
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      size: "default",
      onClick: _cache[8] || (_cache[8] = $event => $data.bhmx.ball_mx.visible = false)
    }, {
      default: _withCtx(() => [_hoisted_26]),
      _: 1
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table, {
      data: $data.bhmx.ball_mx.list,
      border: "",
      size: "samll",
      "highlight-current-row": "",
      "header-cell-class-name": "table-header-cell",
      "header-row-class-name": "table-header-row"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        property: "ball",
        label: "号码",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", {
          style: _normalizeStyle({
            color: scope.row.color
          })
        }, _toDisplayString(scope.row.ball), 5)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "method",
        label: "玩法",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        property: "control_let",
        label: "补出金额",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        property: "rate",
        label: "赔率",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", _hoisted_25, _toDisplayString(scope.row.rate), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        property: "let_res",
        label: "补货时间",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.posttime)), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  }, 8, ["modelValue"])]);
}